import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomDateSelect from './CustomDateSelect.js';
import CustomAlert from '../components/CustomAlert.js';
import { WAButton } from '../components/Button.js';

class JobInfoForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null };
    }

    render() {

        const { handleSubmit, submitting, error } = this.props;

        const vehicle = [{id:0, name:'Auto'},{id:1, name:'Moto'},{id:2, name:'No'}]
        const type_job = [{id:0, name:'Empleado Público Planta Permanente'},{id:1, name:'Empleado Público No Permanente'},{id:2, name:'Empleado En Empresa Privada'},{id:3, name:'Jubliado / Pensionado'}]
        const wage_garnishment = [{id:0 , name:'Sí'}, {id:1 , name:'No'}]

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_job_info" description="Job info"/>
                        <WAButton phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveJobInfo)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="vehicle" defaultValue="¿Tenés vehículo?" label="¿Tenés vehículo?" attributeName='vehicle' attributeOptions={vehicle}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="job_type" defaultValue="Tipo de trabajo:" label="Tipo de trabajo:" attributeName='type_job' attributeOptions={type_job}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <CustomDateSelect type='select' />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="wage_garnishment" defaultValue="¿Tenés el sueldo embargado?" label="¿Tenés el sueldo embargado?" attributeName='wage_garnishment' attributeOptions={wage_garnishment}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

JobInfoForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'vehicle', required: true},
                                  {name: 'job_type', required: true},
                                  {name: 'init_date', required: true},
                                  {name: 'wage_garnishment', required: true}]);

JobInfoForm = TopScrolleable(JobInfoForm);

JobInfoForm = reduxForm({
    form: 'JobInfoForm', // a unique name for this form
    validate
})(JobInfoForm);

JobInfoForm = withAuthControl(JobInfoForm);

export default JobInfoForm;


/** WEBPACK FOOTER **
 ** ./src/components/JobInfoForm.js
 **/